import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ClienteDashboardComponent } from './cliente-dashboard.component';
import { ClienteCadastroSituacaoChartModule } from '../charts';

@NgModule({
    imports: [
        SharedModule,
        ClienteCadastroSituacaoChartModule
    ],
    declarations: [
        ClienteDashboardComponent
    ],
    exports: [
        ClienteDashboardComponent
    ]
})
export class ClienteDashboardModule { }
